import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const RootContainer = styled.div`
  width: 100%;
  border-bottom: 2px solid #DBDEE2;
`;

const StyledTabsContainer = withStyles(() => ({
  root: {
    flex: '1 0 auto',
    width: '100%',
    paddingTop: '16px',
    backgroundColor: '#FFF',
  },
  indicator: {
    backgroundColor: '#0CA58B',
    height: '4px',
  },
  flexContainer: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))(Tabs);

const StyledTab = withStyles(() => ({
  root: {
    color: '#A2AAB3',
    fontSize: '18px',
    fontWeight: 'bold',
    textTransform: 'none',
  },
  selected: {
    color: '#0CA58B',
  },
}))(Tab);

const DaySelector = ({
  days,
  activeIndex,
  onDaySelected,
}) => (
  <RootContainer>
    <StyledTabsContainer
      value={activeIndex}
      onChange={(_, selectedIndex) => {
        onDaySelected(selectedIndex);
      }}
      variant="scrollable"
      scrollButtons="auto"
    >
      {
        days.map((day, index) => (
          <StyledTab
            key={index}
            label={day}
          />
        ))
      }
    </StyledTabsContainer>
  </RootContainer>
);

DaySelector.propTypes = {
  days: PropTypes.arrayOf(PropTypes.string),
  activeIndex: PropTypes.number,
  onDaySelected: PropTypes.func,
};

DaySelector.defaultProps = {
  days: [],
  activeIndex: 0,
  onDaySelected: () => {},
};

export default DaySelector;
